import React, { FC, ReactElement } from 'react';
import styles from './yo-alert.module.sass';
import { Alert } from 'react-bootstrap';

export interface YoAlertProps {
    text: string,
    icon?: ReactElement,
    bodyText?: string
}


export const YoAlert: FC<YoAlertProps> = (props) => {

    return (
        <Alert className={styles.yoAlert}>
            <h3 className="d-block text-lg">{props.text}</h3>
            {props.icon && props.icon}
            {props.bodyText && <p>{props.bodyText}</p>}
        </Alert>
    );
};
